var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bb-panel-wrapper"},[_c('PricingScenarios',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeForm === 1),expression:"activeForm === 1"}]}),(_vm.activeForm === 2)?_c('PricingProducts'):_vm._e(),(_vm.activeForm === 3)?_c('PricingError'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }